import { Component } from '@angular/core';
import { NavigationEnd,  Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(private router: Router) {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(regs => {
        regs.forEach(r => r.unregister());
        // console.log('Unregister serviceWorker...')
      });
    }
  }

  ngOnInit() {
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     const url = event.urlAfterRedirects;
    //     const urlParts = url.split('/').filter(p => p);
    //     console.log({
    //       url,
    //       urlParts,
    //       navigator: navigator.userAgent,
    //       referrer: document.referrer,
    //       title: document.title,
    //       screenWidth: screen.width,
    //       screenHeight: screen.height,
    //       language: navigator.language,
    //     })
    //   }
    // });
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true;

    if (isStandalone) {
      document.body.innerHTML = `
        <div style="
          display:flex;
          align-items:center;
          justify-content:center;
          min-height:100vh;
          background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
          font-family: 'Tahoma', 'Segoe UI', sans-serif;
          padding:20px;
          margin:0;
          box-sizing:border-box;">
          
          <div style="
            background:white;
            border-radius:16px;
            box-shadow: 0 10px 40px rgba(0,0,0,0.1);
            padding: 40px 30px;
            max-width: 420px;
            width:100%;
            text-align:center;">
            
            <!-- آیکون هشدار -->
            <div style="
              width:80px;
              height:80px;
              background:#fff3cd;
              border-radius:50%;
              display:flex;
              align-items:center;
              justify-content:center;
              margin: 0 auto 24px;
              font-size:40px;">
              ⚠️
            </div>
            
            <!-- عنوان -->
            <h2 style="
              color: #d32f2f;
              margin: 0 0 16px;
              font-size: 22px;
              font-weight: 700;">
              این نسخه دیگر پشتیبانی نمی‌شود
            </h2>
            
            <!-- توضیح اصلی -->
            <p style="
              color: #555;
              margin: 0 0 28px;
              font-size: 15px;
              line-height: 1.6;">
              لطفاً این اپلیکیشن را از دستگاه خود حذف کرده و از نسخه وب استفاده کنید
            </p>
            
            <!-- دستورالعمل‌های موبایل -->
            <div style="
              background: #e3f2fd;
              border-radius: 12px;
              padding: 20px;
              margin-bottom: 16px;
              text-align:right;
              direction:rtl;">
              <div style="
                display:flex;
                align-items:center;
                justify-content:center;
                gap: 10px;
                margin-bottom: 12px;
                font-size: 24px;">
                📱 اندروید / iOS
              </div>
              <p style="
                margin: 0;
                color: #1565c0;
                font-size: 14px;
                line-height: 1.7;">
                ۱. روی آیکون اپلیکیشن <strong>نگه دارید</strong><br>
                ۲. گزینه <strong>Remove</strong> یا <strong>حذف</strong> را بزنید<br>
                یا از بخش Settings > Apps اقدام کنید
              </p>
            </div>
            
            <!-- دستورالعمل‌های دسکتاپ -->
            <div style="
              background: #f3e5f5;
              border-radius: 12px;
              padding: 20px;
              margin-bottom: 28px;
              text-align:right;
              direction:rtl;">
              <div style="
                display:flex;
                align-items:center;
                justify-content:center;
                gap: 10px;
                margin-bottom: 12px;
                font-size: 24px;">
                💻 ویندوز / مک
              </div>
              <p style="
                margin: 0;
                color: #7b1fa2;
                font-size: 14px;
                line-height: 1.7;">
                ۱. روی آیکون اپلیکیشن <strong>راست‌کلیک</strong> کنید<br>
                ۲. گزینه <strong>Uninstall</strong> را بزنید<br>
                یا از Settings > Apps اقدام کنید
              </p>
            </div>
          </div>
        </div>
      `;
    }

  }

  title = 'fleetYar';
}
